/**
 * Companies Service
 * Handles company-related API calls
 */

import api from './api';

class CompaniesService {
  /**
   * Get all companies
   * @param {Object} filters - Filter options
   */
  async getCompanies(filters = {}) {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.search) params.append('search', filters.search);
    if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
    if (filters.hasClients !== undefined) params.append('hasClients', filters.hasClients);

    const queryString = params.toString();
    const url = `/company${queryString ? `?${queryString}` : ''}`;

    const response = await api.get(url);

    if (response.success && response.data) {
      return {
        companies: response.data.companies || response.data,
        pagination: response.data.pagination || null,
      };
    }

    throw new Error('Failed to fetch companies');
  }

  /**
   * Get company by ID
   * @param {string} companyId - Company ID
   */
  async getCompanyById(companyId) {
    const response = await api.get(`/company/${companyId}`);

    if (response.success && response.data) {
      return response.data.company || response.data;
    }

    throw new Error('Failed to fetch company');
  }
}

const companiesService = new CompaniesService();
export default companiesService;
